import { BaseSyntheticEvent, Dispatch, SetStateAction } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { appColors } from "../../../../../theme";

const WarrantyJobConfirmDialog = ({
  setOpenWarrantyJobDialog,
  openWarrantyJobDialog,
  setIsWarrantyJob,
}: {
  setOpenWarrantyJobDialog: Dispatch<SetStateAction<boolean>>;
  openWarrantyJobDialog: boolean;
  setIsWarrantyJob: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <Dialog fullWidth={true} maxWidth={"sm"} open={openWarrantyJobDialog}>
      <DialogTitle>
        <Typography
          fontSize={22}
          fontWeight={500}
          color={appColors.primary}
          textAlign={"left"}
        >
          Confirm
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: "2em" }}>
        <Box>
          <Typography variant="body1">Is this a Warranty Job?</Typography>
        </Box>
        <Box sx={{ width: "100%", display: "flex" }}>
          <Button
            onClick={() => {
              setIsWarrantyJob(false);
              setOpenWarrantyJobDialog(false);
            }}
            sx={{ width: 150, marginLeft: "auto", marginTop: "1.5em" }}
          >
            No
          </Button>
          <Button
            onClick={() => {
              setIsWarrantyJob(true);
              setOpenWarrantyJobDialog(false);
            }}
            sx={{ width: 150, marginLeft: ".5em", marginTop: "1.5em" }}
          >
            Yes
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WarrantyJobConfirmDialog;
